export default "__VITE_ASSET__BbPpWEsQ__"